import {combineReducers} from 'redux';

import commentsReducer from './commentsReducer';
import shareReducer from './shareReducer';
import userReducer from './userReducer';

export default combineReducers({
    comments: commentsReducer,
    share: shareReducer,
    user: userReducer
});
